import React from 'react';
import TabLayoutProvider from './hooks/useTabLayout';

import { TabLayoutProps } from './@types/TabLayoutProps';
import SelectTabProvider from './hooks/useSelectTab';
import TabLayoutContainer from './handles/TabLayoutContainer';

const TabLayout = (props: TabLayoutProps) => {
	const [selectedTab, setSelectTab] = React.useState<string>('tab-1');
	return (
		<TabLayoutProvider {...props}>
			<TabLayoutContainer>
				<SelectTabProvider selectedTab={selectedTab} setSelectedTab={setSelectTab}>
					{props.children}
				</SelectTabProvider>
			</TabLayoutContainer>
		</TabLayoutProvider>
	);
};

export default TabLayout;
